import { Suspense, type PropsWithChildren, type FC } from "react";

import { Column, Spinner } from "@hightouch/htui";

import { useHoldsFloatingToggle } from "src/components/layout/nav/mini-nav/mini-nav-context";

export const PageSuspense: FC<PropsWithChildren> = ({ children }) => {
  return <Suspense fallback={<PageSuspenseFallback />}>{children}</Suspense>;
};

const PageSuspenseFallback = () => {
  useHoldsFloatingToggle();
  return (
    <Column height="100%" width="100%" align="center" justify="center">
      <Spinner size="lg" m="auto" />
    </Column>
  );
};
